<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '140px' : '120px'">
      <el-form-item label="标题" prop="title">
        <el-input v-model="dataForm.title" placeholder="标题"></el-input>
      </el-form-item>
      <el-form-item label="跳转地址" prop="url">
          <el-input v-model="dataForm.url" placeholder="跳转地址"></el-input>
      </el-form-item>
      <!-- <el-form-item label="新图片链接地址" prop="image1">
        <el-input v-model="dataForm.image1" placeholder="图片链接地址（可手动输入或通过下方上传）"></el-input>
      </el-form-item>
      <el-form-item label="URL上传到MinIO">
        <UrlUpload
          ref="urlUpload"
          :show-progress="true"
          :show-webp-config="true"
          :convert-to-web-p="webpConfig.convertToWebP"
          :webp-quality="webpConfig.webpQuality"
          :bucket="webpConfig.bucket"
          @success="handleImageUpload"
        />
      </el-form-item> -->
      <el-form-item label="上传新图片" prop="image1">
        <ImageUpload :limit="1"
          v-model="dataForm.image1"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
      </el-form-item>
      <el-form-item label="排序" prop="orderNo">
        <el-input-number v-model="dataForm.orderNo" :step="1"></el-input-number>

      </el-form-item>
      <el-form-item label="备注" prop="comment">
        <el-input v-model="dataForm.comment" placeholder="备注"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
import UrlUpload from '@/components/UrlUpload'
import { getMinioBucket } from '@/api/system/config'
export default {
  components: {
    UrlUpload
  },
  data () {
    return {
      imageType: ["jpg","jpeg","png","gif","bmp","webp"],
      visible: false,
      img:'',
      image1: '',
      url:'',
      webpConfig: {
        convertToWebP: true,
        webpQuality: 'smallest',
        bucket: ''
      },
      dataForm: {
        title:'',
        comment:'',
        id: '',
        url: '',
        img: '',
        image1: '',
        orderNo: 0
      }
    }
  },
  computed: {
    dataRule () {
      return {
        title: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.fetchBucket()
  },
  methods: {
    async fetchBucket() {
      try {
        const response = await getMinioBucket()
        if (response && response.data) {
          this.webpConfig.bucket = response.data
        }
      } catch (error) {
        console.error('获取 bucket 配置失败:', error)
        this.webpConfig.bucket = 'kanbei'
      }
    },
    handleImageUpload(imageUrl) {
      if (imageUrl) {
        this.dataForm.image1 = imageUrl
      }
    },
    init () {
      this.img='';
      this.image1='',
      this.url = `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/sys/oss/upload?token=${Cookies.get('token')}`
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        // 重置 UrlUpload 组件状态
        if (this.$refs.urlUpload) {
          this.$refs.urlUpload.reset()
        }
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/squaread/squaread/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.img= this.dataForm.img
        this.dataForm.image1= this.dataForm.img
      }).catch(() => {})
    },
    // 上传之前
    beforeUploadHandle (file) {

       return true;
   },
    successHandle(fileList){
      if(fileList.length>0){
        this.img = fileList[0].url
      }else{
        this.img=""
      }

      this.dataForm.img = this.img
    },
       // 上传成功
   successHandle_old (res, file) {
     if(res.code == 0){
       this.img = res.data.src,
       this.dataForm.img = res.data.src
     }else{
       return this.$message.error(res.msg)
     }
   },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.img = this.dataForm.image1
        this.$http[!this.dataForm.id ? 'post' : 'put']('/squaread/squaread/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
